import ArticleCard from "@/components/feature/ArticleCard";
import type { Article } from "@/mocks/articles";

interface ArchiveGridProps {
  articles: Article[];
  visibleCount: number;
  onLoadMore: () => void;
}

export default function ArchiveGrid({ articles, visibleCount, onLoadMore }: ArchiveGridProps) {
  if (articles.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-700 bg-background-900 px-6 py-20 text-center">
        <span className="flex h-14 w-14 items-center justify-center rounded-full bg-background-800 text-2xl text-foreground-500">
          <i className="ri-file-search-line" />
        </span>
        <h2 className="mt-5 font-heading text-lg font-semibold text-foreground-100">没有匹配的档案</h2>
        <p className="mt-2 max-w-md text-sm text-foreground-400">
          换一个关键词，或切换到其它分类看看。也可以直接浏览全部档案，再慢慢筛选。
        </p>
      </div>
    );
  }

  const visible = articles.slice(0, visibleCount);
  const hasMore = visibleCount < articles.length;

  return (
    <div>
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {visible.map((article) => (
          <ArticleCard key={article.slug} article={article} />
        ))}
      </div>

      <div className="mt-10 flex flex-col items-center gap-3">
        {hasMore ? (
          <button
            type="button"
            onClick={onLoadMore}
            className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-700 px-6 py-3 text-sm text-foreground-200 transition-colors hover:border-primary-400 hover:text-primary-300"
          >
            <i className="ri-arrow-down-line" /> 加载更多档案
          </button>
        ) : (
          <p className="text-xs text-foreground-500">已经到底了，所有档案都在这里。</p>
        )}
        <p className="text-xs text-foreground-600">
          已显示 {visible.length} / {articles.length} 篇
        </p>
      </div>
    </div>
  );
}